import { YOO_FINDS_CDN } from "@/common";

export * from "./fgvcon-2025";

export const YOOFINDS_WS_QRCOD = `${YOO_FINDS_CDN}/pc/yoofinds_ws_qrcod.jpeg`;
export const SAMPLE_GUIDE_LIST = [
  `${YOO_FINDS_CDN}/pc/authorization-process/pc-lead-auth-1.png`,
  `${YOO_FINDS_CDN}/pc/authorization-process/pc-lead-auth-2.png`,
  `${YOO_FINDS_CDN}/pc/authorization-process/pc-lead-auth-3.png`,
  `${YOO_FINDS_CDN}/pc/authorization-process/pc-lead-auth-4.png`,
  `${YOO_FINDS_CDN}/pc/authorization-process/pc-lead-auth-5.png`,
];

export const BLACK_RANKING_BANNER = `${YOO_FINDS_CDN}/pc/black-friday/black-friday-banner.png`;

export const BLACK_RANKING_STEP = `${YOO_FINDS_CDN}/pc/black-friday/download-step.webp`;

export const BLACK_RANKING_RANK = `${YOO_FINDS_CDN}/pc/black-friday/rank.png`;

export const CHRISTMAS_BANNER = `${YOO_FINDS_CDN}/pc/banner/christmas-topbanner.png`;

export const ICE_BANNER = `${YOO_FINDS_CDN}/pc/banner/ice-banner.png`;

export const RANKING = `${YOO_FINDS_CDN}/pc/christmas/ranking.png`;

// 圣诞详情
export const DETAILS_CHRISTMAS_BANNER = `${YOO_FINDS_CDN}/pc/christmas/details-christmasbanner.png`;

export const DETAILS_CHRISTMAS_FOOTER = `${YOO_FINDS_CDN}/pc/christmas/details-christmasfooter.png`;

export const EAR_OF_WHEAT = `${YOO_FINDS_CDN}/pc/christmas/ear-of-wheat.png`;

export const PRODUCT_DEFAULT_ICON = `${YOO_FINDS_CDN}/pc/product-default.png`;

export const MODAL_BG = `${YOO_FINDS_CDN}/pc/modal-bg.png`;

export const RESTRICTED_MODAL_BG = `${YOO_FINDS_CDN}/pc/restricted-modal-bg.png`;

export const LOW_BANNER = `${YOO_FINDS_CDN}/pc/low-price/newcomer.png`;

export * from "./about-us";
export * from "./brand";
export * from "./product";
export * from "./winter";
export * from "./open-graph";
export * from "./creators-salon";
export * from "./dallas-2025";
export * from "./personal-center";
export * from "./la-2025";
